import {
  BasicIconButton,
  BrandIconSpinner,
  Button,
  CustomPopover,
  Modal,
} from 'components';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DynModel from 'components/Modal';
import { t } from 'i18next';
import { EndStyle, PostPopOver } from 'pages/home/Home.style';
import { ClearLoading, SetLoading } from 'redux/services/LoadingService';
import { Notification } from 'components/CustomNotification';
import {
  addBuinessPlace,
  DeleteBuinessByuserId,
  getBuinessPlaceList,
  getBuinessPlaceListBySearch,
  getBuinessPlaceListByUsername,
  resetBuinessPlaceList,
  resetBusinessImage,
} from 'redux/features/BuinessPlaceSlice';
import CustomCarousel from 'components/CustomCarousel';
import { Divider, Rating } from '@mui/material';
import { VirtuosoGrid } from 'react-virtuoso';
import BusinessImages from './BusinessImages';
import { useNavigate } from 'react-router-dom';
import { WaterMark } from 'pages/network/Network.style';
import {
  BusinessList,
  LoaderContainer,
  PostedUserDetails,
  RatingsContainer,
} from './Buisness.style';

import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { ReactComponent as PostEdit } from 'assert/images/More/postEdit.svg';
import { ReactComponent as Add } from 'assert/images/Profile/add.svg';
import { ReactComponent as ViewList } from 'assert/images/Jobs/viewList.svg';
import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import { ReactComponent as OpenInNew } from 'assert/images/Common/openInNew.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as SampleProfile } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as Report } from 'assert/images/More/report.svg';
import {
  businessList,
  businessListByUsername,
  commonsearch,
  landingBusiness,
} from 'redux/APIEndPoint';
import moment from 'moment';
import clsx from 'clsx';
import { AuthContext } from 'router/AuthProvider';
import LoginNotification from 'pages/auth/LoginNotification';
import useWindowDimensions from 'components/Dimention';
import { handleOpenLinkInBrower, swipeModalWidth } from 'utils/helper';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import ReportModal from 'components/ReportModal';

export const BusinessRatings = ({
  data,
  handleUpdateData,
  handleUpdateLoginNotify,
}) => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useContext(AuthContext);
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const [currentRatings, setCurrentRatings] = useState(0);
  const [openRatingModal, setOpenRatingModal] = useState(false);
  const [starValue, setStarValue] = useState(null);

  const handleAddRating = (id, val) => {
    const payload = {
      businessPageId: id,
      ratings: val,
    };
    dispatch(SetLoading());
    dispatch(addBuinessPlace(payload, 'businessPage/ratings', 'post'))
      .then((res) => {
        dispatch(ClearLoading());
        if (res.data.success === true) {
          setCurrentRatings(val);
          handleUpdateData(res.data.data);
          setOpenRatingModal(false);
          Notification('success', res?.data?.message);
        } else {
          Notification('warning', res?.data?.message);
        }
      })
      .catch((value) => {
        dispatch(ClearLoading());
        Notification('error', value?.response?.data?.message);
      });
  };

  const handleGetRatingsContent = () => {
    return (
      <RatingsContainer>
        <div className="user-ratings">
          <table className="table-no-border">
            <thead>
              <tr>
                <th>{t('BusinessPlace.Ratings')}</th>
                <th>{t('BusinessPlace.UserCount')}</th>
              </tr>
            </thead>
            <tbody>
              {data?.ratingsList?.[0] &&
                Object.keys(data.ratingsList?.[0]).map((_, index) => {
                  const stars = data.ratingsList?.[0]?.[5 - index + '_star'];
                  return (
                    <tr key={index}>
                      <td>
                        <Rating readOnly value={5 - index} />
                      </td>
                      <td className="total-stars">{stars}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <Divider />
        <div className="rating-action-container">
          <div>{t('BusinessPlace.RatingFeedback')}</div>
          <div className="rating-action">
            <Rating
              readOnly={data?.ratings}
              value={starValue === null ? data?.ratings : starValue}
              onChange={(_, newValue) => {
                setStarValue(newValue);
              }}
            />
            <div className="rating-action-text">
              {starValue === null ? data?.ratings || currentRatings : starValue}
            </div>
          </div>
          {!data?.ratings && (
            <Button
              className="rating-submit"
              label={t('BusinessPlace.Submit')}
              onClick={() => {
                if (isLoggedIn) {
                  handleAddRating(data.id, starValue);
                } else {
                  handleUpdateLoginNotify && handleUpdateLoginNotify(true);
                }
              }}
            />
          )}
        </div>
      </RatingsContainer>
    );
  };

  return (
    <>
      <div className="rating-star" onClick={() => setOpenRatingModal(true)}>
        <Rating readOnly value={data?.overAllRating} />
        {data?.overAllRating && (
          <span className="overall-rating">{data?.overAllRating}</span>
        )}
      </div>
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          openDrawer={openRatingModal}
          handleCloseDrawer={() => {
            setOpenRatingModal(false);
            setCurrentRatings(0);
          }}
        >
          {handleGetRatingsContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          modalchanges={'ratings-modal'}
          modelTitle={t('BusinessPlace.Ratings')}
          openModal={openRatingModal}
          handleCancelModal={() => {
            setOpenRatingModal(false);
            setCurrentRatings(0);
          }}
          content={handleGetRatingsContent()}
        />
      )}
    </>
  );
};

export default function BuinessPlaceLists({
  handleSetEditData,
  handleOpen,
  ScrollData,
  businessCategoryState,
  editedItem,
  isProfile,
  keyword,
  searchValue,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const disableRecall = useRef(true);
  const { isLoggedIn } = useContext(AuthContext);
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const { loading } = useSelector((state) => state.Loading);
  const { getLists, getImages } = useSelector(
    (state) => state.BusinessPlaceSlice
  );
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [list, setList] = useState([]);
  const [isHasMore, setIsHasMore] = useState(false);
  const [scrollData, setScrollData] = useState({ page: 0, size: 10 });
  const [businessImgData, setBusinessImgData] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(null);
  const [openPopover, setOpenPopover] = useState(false);
  const [ImageEdit, setImageEdit] = useState(false);
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  useEffect(() => {
    setScrollData({
      page: 0,
      size: 10,
    });
  }, [searchValue]);

  useEffect(() => {
    if (getLists?.rows && !disableRecall.current) {
      setList([...list, ...getLists.rows]);
      setIsHasMore(getLists.hasMore);
    } else {
      setList([]);
    }
  }, [getLists]);

  useEffect(() => {
    if (editedItem?.id) {
      handleUpdateData(editedItem);
    }
  }, [editedItem]);

  useEffect(() => {
    setList([]);
  }, [businessCategoryState]);

  useEffect(() => {
    if (disableRecall.current && (getProfile?.username || !isLoggedIn)) {
      disableRecall.current = false;
      if (isProfile) {
        dispatch(
          getBuinessPlaceListByUsername(
            `${businessListByUsername}/${
              getProfile?.username
            }?page=0&size=10&clientOffSet=${new Date().getTimezoneOffset()}`
          )
        );
      } else if (keyword) {
        dispatch(
          getBuinessPlaceListBySearch(
            `${commonsearch}/businessPage?keyword=${encodeURIComponent(
              keyword
            )}&page=0&size=10&clientOffSet=${new Date().getTimezoneOffset()}`
          )
        );
      } else if (!isLoggedIn) {
        dispatch(getBuinessPlaceList(landingBusiness));
      } else {
        dispatch(
          getBuinessPlaceList(
            `${businessList}?keyword=${searchValue}&page=0&size=10&clientOffSet=${new Date().getTimezoneOffset()}`
          )
        );
      }
    }
    return () => {
      dispatch(resetBuinessPlaceList());
    };
  }, [getProfile]);

  useEffect(() => {
    ScrollData(scrollData);
  }, [scrollData]);

  const PostDropdown = (item) => {
    return (
      <PostPopOver>
        {getProfile?.userId === item?.createdBy ? (
          <>
            <div
              onClick={() => {
                handleOpen(true);
                handleSetEditData(item);
                setOpenPopover(false);
              }}
            >
              <PostEdit />
              <div>{t('HomePage.EditThePost')}</div>
            </div>
            <div
              onClick={() => {
                setBusinessImgData(item);
                item?.image?.length > 0 && setImageEdit(true);
                setOpenPopover(false);
              }}
            >
              <Add className="editlist-icon" />
              <div>
                {item?.image?.length > 0
                  ? t('BusinessPlace.AddEditImage')
                  : t('BusinessPlace.AddImages')}
              </div>
            </div>
            <div
              onClick={() => {
                setDeleteOpen(item.id);
                setOpenPopover(false);
              }}
              className="deletelist-icon"
            >
              <Delete />
              <div>{t('HomePage.Delete')}</div>
            </div>
          </>
        ) : (
          <div
            onClick={() => {
              setIsReportModalOpen(item?.id);
            }}
            className="deletelist-icon"
          >
            <Report />
            <div>{t('BusinessPlace.Report')}</div>
          </div>
        )}
      </PostPopOver>
    );
  };

  const handleDeleteListItem = () => {
    dispatch(SetLoading());
    dispatch(DeleteBuinessByuserId(`/${deleteOpen}`))
      .then((res) => {
        setDeleteOpen(null);
        if (res.data.success === true) {
          Notification('success', res?.data?.message);
          dispatch(resetBuinessPlaceList());
          setList([]);
          if (isProfile) {
            dispatch(
              getBuinessPlaceListByUsername(
                `${businessListByUsername}/${
                  getProfile?.username
                }?page=0&size=10&clientOffSet=${new Date().getTimezoneOffset()}`
              )
            );
          } else if (keyword) {
            dispatch(
              getBuinessPlaceListBySearch(
                `${commonsearch}/businessPage?keyword=${encodeURIComponent(
                  keyword
                )}&page=0&size=10&clientOffSet=${new Date().getTimezoneOffset()}`
              )
            );
          } else {
            dispatch(
              getBuinessPlaceList(
                `${businessList}?keyword=${searchValue}&page=0&size=10&clientOffSet=${new Date().getTimezoneOffset()}`
              )
            );
          }
        } else {
          Notification('warning', res?.data?.message);
        }
        setTimeout(() => {
          setDeleteOpen(null);
          dispatch(ClearLoading());
        }, 300);
      })
      .catch(() => {
        setTimeout(() => {
          setDeleteOpen(null);
          dispatch(ClearLoading());
        }, 300);
      });
  };

  const fetchMoreData = () => {
    setScrollData({
      page: scrollData.page + 1,
      size: scrollData.size,
    });
    if (isProfile) {
      dispatch(
        getBuinessPlaceListByUsername(
          `${businessListByUsername}/${getProfile?.username}?page=${
            scrollData.page + 1
          }&size=${
            scrollData.size
          }&clientOffSet=${new Date().getTimezoneOffset()}`
        )
      );
    } else if (keyword) {
      dispatch(
        getBuinessPlaceListBySearch(
          `${commonsearch}/businessPage?keyword=${encodeURIComponent(
            keyword
          )}&page=${scrollData.page + 1}&size=${
            scrollData.size
          }&clientOffSet=${new Date().getTimezoneOffset()}`
        )
      );
    } else if (!isLoggedIn) {
      dispatch(getBuinessPlaceList(landingBusiness));
    } else {
      dispatch(
        getBuinessPlaceList(
          `businessPage/findAll?keyword=${searchValue}&page=${
            scrollData.page + 1
          }&size=${
            scrollData.size
          }&clientOffSet=${new Date().getTimezoneOffset()}`
        )
      );
    }
  };

  const handleUpdateData = (data) => {
    const selectedIndex = list.findIndex((ele) => ele.id === data.id);
    list[selectedIndex] = data;
    setList([...list]);
  };

  useEffect(() => {
    if (getImages?.businessPageId && list.length) {
      const selectedIndex = list.findIndex(
        (ele) => ele.id === getImages.businessPageId
      );
      list[selectedIndex] = {
        ...list[selectedIndex],
        image: getImages.image,
      };
      setList([...list]);
      dispatch(resetBusinessImage());
    }
  }, [getImages]);

  const handleItemContent = (index, data) => {
    return (
      <div className="cardhr-div business-list" key={index}>
        {data?.image?.length > 0 ? (
          <CustomCarousel
            items={data.image}
            display={'inherit'}
            className="business-page-carousel"
          />
        ) : (
          <div style={{ height: '250px' }}>
            <WaterMark>
              {[...Array(6)].map((_, index) => {
                return (
                  <div key={index} className="business-watermark-text">
                    {data.name || 'WafyNet'}
                  </div>
                );
              })}
            </WaterMark>
          </div>
        )}
        <div className="card-in-div">
          <div
            className="company-link"
            onClick={() => handleOpenLinkInBrower(data?.website)}
          >
            {data?.name} <OpenInNew />
          </div>
          <div className="list-date">
            {moment(data?.updatedAt).fromNow(true)}
          </div>
          <div className="list-title">{data.title}</div>
          <p>{data.contact}</p>
          <Divider />
          <PostedUserDetails>
            <div className="posted-user-title">
              {t('BusinessPlace.Postedby')}
            </div>
            <div className="posted-user-container">
              <div className="posted-user-img">
                {data.postedUserInfo.profileImage ? (
                  <img
                    className="user-profile-img"
                    src={data.postedUserInfo.profileImage}
                  />
                ) : (
                  <SampleProfile className="user-profile-img" />
                )}
              </div>
              <div className="posted-username-details">
                <div className="posted-name-container">
                  <span
                    onClick={() =>
                      navigate('/profile/' + data.postedUserInfo.username)
                    }
                  >
                    {data.postedUserInfo.displayName}
                  </span>
                  <span className="posted-username">
                    {' '}
                    · {` @${data.postedUserInfo.username}`}
                  </span>
                </div>
                <div className="posted-headline">
                  {data.postedUserInfo.headline}
                </div>
              </div>
            </div>
          </PostedUserDetails>
          <div className="rating-container">
            <BusinessRatings
              data={data}
              handleUpdateData={handleUpdateData}
              handleUpdateLoginNotify={() => setIsLoginNotificationOpen(true)}
            />
            {isProfile && (
              <div className="status-context">
                {data.status === 0 ? (
                  <div className="pending">Pending</div>
                ) : data.status === 1 ? (
                  <div className="approved">Approved</div>
                ) : (
                  <div className="rejected">Rejected</div>
                )}
              </div>
            )}
            <BasicIconButton
              icon={
                <ViewList
                  className="detailIcon"
                  onClick={() => {
                    if (isLoggedIn) {
                      navigate(`/business-hub/detail/${data.id}`);
                    } else {
                      setIsLoginNotificationOpen(true);
                    }
                  }}
                />
              }
              size="small"
              className="post-more-btn"
            />
          </div>
        </div>
        <div className="custom-popover">
          <CustomPopover
            isOpen={openPopover}
            handlePopoverClick={() => {
              if (isLoggedIn) {
                setOpenPopover(true);
              } else {
                setIsLoginNotificationOpen(true);
              }
            }}
            disableRefClick={!isLoggedIn}
            action={
              <BasicIconButton
                icon={<More onClick={() => setOpenPopover(true)} />}
                size="small"
              />
            }
            content={PostDropdown(data)}
          />
        </div>
      </div>
    );
  };

  return (
    <BusinessList>
      {list.length === 0 && loading && (
        <LoaderContainer>
          <BrandIconSpinner loading={list.length === 0 && loading} />
        </LoaderContainer>
      )}
      {list.length > 0 && (
        <VirtuosoGrid
          className={clsx(
            `Business-VirtuosoGrid ${
              (isProfile || keyword) && 'Profile-Business-VirtuosoGrid'
            }`
          )}
          data={list}
          useWindowScroll
          increaseViewportBy={{ top: 2000, bottom: 1000 }}
          components={{
            Footer: () => {
              return (
                !isHasMore && (
                  <EndStyle>
                    <span>* * *</span>
                  </EndStyle>
                )
              );
            },
          }}
          endReached={isHasMore ? fetchMoreData : () => {}}
          itemContent={(index, item) => handleItemContent(index, item)}
        />
      )}
      {list.length === 0 && !loading && (
        <div className="no-data-found">
          <NoDataFound />
          <div>{t('BusinessPlace.NoDataFound')}</div>
        </div>
      )}
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          title={t('BusinessPlace.BusinessImages')}
          openDrawer={businessImgData}
          handleCloseDrawer={() => setBusinessImgData(null)}
        >
          <BusinessImages
            businessImgData={businessImgData}
            ImageEdit={ImageEdit}
            handleCancelModal={() => setBusinessImgData(null)}
            autoPlay={false}
          />
        </SwipeableEdgeDrawer>
      ) : (
        <DynModel
          handleCancelModal={() => setBusinessImgData(null)}
          openModal={businessImgData}
          modalchanges={'comment-modal'}
          modelTitle={t('BusinessPlace.BusinessImages')}
          content={
            <BusinessImages
              businessImgData={businessImgData}
              ImageEdit={ImageEdit}
              handleCancelModal={() => setBusinessImgData(null)}
              autoPlay={false}
            />
          }
        />
      )}
      <Modal
        removeHeader
        modalchanges="headerProfile"
        handleCancelModal={() => setDeleteOpen(null)}
        openModal={deleteOpen !== null}
        content={
          <>
            <BrandIconSpinner loading={loading} />
            <div className="confirmModal">
              <div className="title">{t('BusinessPlace.DeleteRecord')}</div>
              <div>
                <Button
                  label={t('BusinessPlace.Cancel')}
                  type="text"
                  onClick={() => setDeleteOpen(null)}
                />
                <Button
                  label={t('BusinessPlace.Yes')}
                  color="error"
                  onClick={handleDeleteListItem}
                />
              </div>
            </div>
          </>
        }
      />
      <LoginNotification
        isLoginNotificationOpen={isLoginNotificationOpen}
        handleUpdateModal={() => setIsLoginNotificationOpen(false)}
      />
      <ReportModal
        resourceType={'businesspage'}
        resourceId={isReportModalOpen}
        handleCloseReportModal={(data) => {
          setIsReportModalOpen(false);
          if (data?.closePopover) {
            setOpenPopover(false);
          }
        }}
      />
    </BusinessList>
  );
}
